import React, { FC } from 'react'

import './Skeleton.scss'

const SkeletonProjectMetrics: FC = () => (
  <>
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '30%' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '50%' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '50%', marginBottom: '36px' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '25%' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '80%' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '18%', marginBottom: '14px' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '90%', marginBottom: '12px' }} />
    <div className="pd-skeleton__line pd-skeleton__info" style={{ width: '70%', marginBottom: '30px' }} />
  </>
)

export default SkeletonProjectMetrics
